<template>
  <div class="default-title">
     <el-form label-width="130px" ref="form" :model="form" class="list-top-margin" :size="buttonSize" :rules="rules">
        <el-row>
          <el-col :span="12">
            <el-form-item label="工序编号" prop="processCode">
              <el-input size="small" v-model="form.processCode" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="工序名称" prop="processName">
              <el-input size="small" v-model="form.processName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="报工权限" prop="workReportAuth">
              <el-input size="small" v-model="form.workReportAuth" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="报工数配比" prop="coefficient">
              <el-input size="small" v-model="form.coefficient" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="不良品项列表" prop="nongoodName">
              <el-select v-model="form.nongoodIdList" filterable placeholder="请选择" multiple clearable disabled style="width: 100%;">
                  <el-option
                      v-for="item in notGoodList"
                      :key="'1'+item._id"
                      :label="item.nongoodName"
                      :value="item._id">
                  </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="计划数" prop="planNum">
              <el-input size="small" v-model="form.planNum" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="良品数" prop="goodNum">
              <el-input size="small" v-model="form.goodNum" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="不良品数" prop="nongoodNum">
              <el-input size="small" v-model="form.nongoodNum" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
             <el-form-item label="计划开始/结束时间" prop="planTime" class="line-height-normal">
                  <el-date-picker
                  size="small"
                  format="yyyy-MM-dd HH:mm"
                  value-format="yyyy-MM-dd HH:mm"
                  style="width: 100%;"
                  v-model="planTime"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  @change="planTimeChange">
                </el-date-picker>
              </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="实际开始/结束时间" prop="actualTime"  class="line-height-normal">
                  <el-date-picker
                  size="small"
                  format="yyyy-MM-dd HH:mm"
                  value-format="yyyy-MM-dd HH:mm"
                  style="width: 100%;"
                  v-model="actualTime"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  @change="actualTimeChange" disabled>
                </el-date-picker>
              </el-form-item>
          </el-col>

        </el-row>
        <FormItem :setList="setList" :form="form" :colSpan="12" :mode="mode" v-if="showChild"></FormItem>

      </el-form>
      <div slot="footer" class="text-align-center" style="position: relative;">
        <el-button size="small" @click="cancel">取 消</el-button>
        <el-button size="small" type="primary" class="title" @click="save">确 定</el-button>
      </div>
  </div>
</template>
<script>
import { getAll} from '@/api/basicData';
import Pagination from '@/components/Pagination';
import FormItem from "@/components/FormItem";

export default {
  components: {
    Pagination,
    FormItem
  },
  props:['editRow','setList','modelStatus','mode'],
  data() {
    return {
      buttonSize:'small',
      form:{
        planNum:'',
      },
      rules:{
      },
      planTime:[],
      actualTime:[],
      notGoodList:[],
      userData:{},
      showChild:true,
    }
  },
  created() {
    this.showChild = true;
    var userData = window.localStorage.getItem('userdata')
    if(userData){
      this.userData = JSON.parse(userData);
      this.form['factoryId'] = this.userData.factoryId;
    }
    if(this.modelStatus == 'edit'){
      this.form = JSON.parse(JSON.stringify(this.editRow));

      this.planTime.push(this.form['planStartTime']?this.form['planStartTime']:'');
      this.planTime.push(this.form['planEndTime']?this.form['planEndTime']:'');


      this.actualTime.push(this.form['actualStartTime']?this.form['actualStartTime']:'');
      this.actualTime.push(this.form['actualEndTime']?this.form['actualEndTime']:'');
    }
    // if(this.setList && this.setList != null){

    //   for(let i = 0;i<this.setList.length;i++){
    //     this.form[this.setList[i]['fieldName']] = this.form[this.setList[i]['fieldName']]?this.form[this.setList[i]['fieldName']]:'';
    //   }
    // }
    // console.log('form',this.form)
    this.getAll()
  },
  methods:{
    // 查询所有不良品项
    getAll(){
      getAll(this.userData.factoryId).then(res => {
        if(res.code == 200){
          this.notGoodList = res.data
        }
      })
    },
    planTimeChange(val){
        this.form['planStartTime'] = val[0];
        this.form['planEndTime'] = val[1];
    },
    actualTimeChange(val){
        this.form['actualStartTime'] = val[0];
        this.form['actualEndTime'] = val[1];
    },
    cancel(){
      this.showChild = false;
      this.$emit('done',{type:'cancel'})
    },
    save(){
      this.$refs.form.validate((valid) => {
          if (valid) {
            this.showChild = false;
            this.$emit('done',{type:'save',data:this.form})
          }
      })

    },
  }
}
</script>
<style>
.list-top-margin .el-input-group__append, .el-input-group__prepend{
  color: #fff;
  background-color: #409EFF;
  border-radius: 0 4px 4px 0;
}
.select-count-content{
  position: absolute;
  left: 0;
  top: -45px;
  font-size: 12px;
}
</style>




// WEBPACK FOOTER //
// src/views/order/dialogManage/order-detail.vue